export default "__VITE_ASSET__C4Dnvb8P__"